<div [formGroup]="frm">
  <label [ngClass]="required ? 'is-required ms-Label' : 'ms-Label'" for="{{formControlName}}">
    {{label}}
  </label>
  <div [class]="typeBox == 'password' ? 'form-group password-input-wrapper' : 'form-group'">
    <input 
      [type]="type" 
      class="text-Create form-control" 
      [formControlName]="formControlName" 
      [placeholder]="label"
      (input)="value = $event.target.value"> <!-- Actualiza el modelo en tiempo real -->
    <span *ngIf="typeBox == 'password'" class="glyphicon" (click)="togglePasswordVisibility()">
      <i [ngClass]="!showPassword ? 'fa-eye' : 'fa-eye-slash'" class="fa"></i>
    </span>
  </div>
  <div style="color: brown;" *ngIf="ctrlInvalid && ctrlTouched" class="text-danger">
    {{label}} no cuenta con el formato correcto.
  </div>

  <!-- Mostrar la longitud actual en comparación con min y max -->
  <div *ngIf="min || max">
    <small>
      {{currentLength}} 
      <span *ngIf="min">/ Mínimo: {{min}}</span> 
      <span *ngIf="max">/ Máximo: {{max}}</span>
    </small>
  </div>
</div>
